import React from 'react';
import Video from '../../Video';

const MediaGalleryVideo = (props) => {
  const {
    activeIndex,
    index,
    numberOfItems,
    counter,
    VideoText,
    slideWidth,
    isMobile,
    alwaysShowCurrentImage,
  } = props;

  const forciblyShowCurrentCount =
    (alwaysShowCurrentImage && !isMobile) ||
    (activeIndex === index && isMobile);

  return (
    <div
      className={`c-media-gallery__item ${
        activeIndex === index ? 'active' : ''
      }`}
      key={index}
      style={{ width: slideWidth }}
    >
      <span className="show-for-sr">
        {counter} {activeIndex + 1}
      </span>

      <div className="c-media-gallery__item__video">
        <Video {...props} VideoText={VideoText} isGallery={true} />
        <div
          style={{
            visibility: forciblyShowCurrentCount ? 'visible' : 'hidden',
          }}
          className="c-media-gallery__current"
        >
          <span>
            {alwaysShowCurrentImage ? index + 1 : activeIndex + 1}/
            {numberOfItems}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MediaGalleryVideo;
